import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { TicketService } from "../../ticket.service";

@Component({
  selector: "app-my-tickets",
  templateUrl: "./my-tickets.component.html",
  styleUrls: ["./my-tickets.component.scss"],
})
export class MyTicketsComponent implements OnInit {
  public ticket_list: any = [];

  public arrayLength: number = 0;

  constructor(
    public _ticketService: TicketService,
    public _utilsService: UtilsService,
  ) {}

  async ngOnInit() {
    this.ticket_list = await this._ticketService.getMineTicket();
    this.arrayLength = this.ticket_list.length - 5;
    this.ticket_list = this.ticket_list.slice(0, 5);
    const completed: any = await this._utilsService.translate("COMPLETED");
    const pending: any = await this._utilsService.translate("PENDING");
    const takenCharge: any = await this._utilsService.translate("TAKEN_CHARGE");
    this.ticket_list.map((item: any) => {
      if (item.steps[0].status === 1) {
        item.enabled_label = takenCharge;
      } else if (item.steps[0].status === 2) {
        item.enabled_label = completed;
      } else {
        item.enabled_label = pending;
      }
    });
  }
}
